import React, { useMemo } from "react";

import { formatCurrency } from "@/utils/formatCurrency";

function Tile({ label, value, accent = "text-[#333333]" }) {
  return (
    <div className="flex flex-col gap-1 min-w-[150px]">
      <p className="text-sm text-[#666]">{label}</p>
      <span className={`text-[20px] font-semibold ${accent}`}>{value}</span>
    </div>
  );
}

const isPaid = (status) => String(status || "").toLowerCase().replace(/[\s_-]+/g, "") === "paid";
const isOverdue = (status) =>
  String(status || "").toLowerCase().replace(/[\s_-]+/g, "") === "overdue";

export default function FinanceSummary({ expenses = [] }) {
  const stats = useMemo(() => {
    let total = 0;
    let outstanding = 0;
    let overdueCount = 0;

    expenses.forEach((exp) => {
      const amount = Number(exp.totalAmount ?? 0);
      total += amount;
      if (!isPaid(exp.paymentStatus)) outstanding += amount;
      if (isOverdue(exp.paymentStatus)) overdueCount += 1;
    });

    return { count: expenses.length, total, outstanding, overdueCount };
  }, [expenses]);

  return (
    <div className="mb-6 rounded-lg bg-white border border-[#e4e4e4] px-5 py-4 shadow-sm">
      <div className="flex flex-wrap gap-8">
        <Tile label="Expenses" value={stats.count} />
        <Tile label="Total Value" value={formatCurrency(stats.total)} />
        <Tile label="Outstanding" value={formatCurrency(stats.outstanding)} accent="text-amber-600" />
        <Tile label="Overdue" value={stats.overdueCount} accent="text-red-600" />
      </div>
    </div>
  );
}
